<h2>{{title}}</h2>

<div>
    <a routerLink="/Hand" routerLinkActive="active">Poker game</a><br/>
    <router-outlet>
    </router-outlet>
</div><br/><br/>
<div>Powered by <a href="www.mickbraz.com">MickBraz.com</a></div>
